import { Link as RouterLink } from "react-router-dom"
import type { ComponentProps } from "react"

export function isInternalHref(href: string) {
  return href.startsWith("/") && !href.startsWith("//")
}

export function MarketingAnchor({
  href,
  ...props
}: { href: string } & Omit<ComponentProps<"a">, "href">) {
  if (isInternalHref(href)) {
    return <RouterLink to={href} {...props} />
  }
  return <a href={href} {...props} />
}
